import React, { useState, useEffect } from 'react';
import {
  useSelector,
} from 'react-redux';

import {
  FORMS__REMIND_PASSWORD,
  FORMS__SIGN_IN,
  FORMS__SIGN_UP,
  FORMS__SIGN_IN_WITH_PASSWORD_CHANGE,
} from './constants';

import Logo from './logo';

import RemindPassword from './remindPassword';
import SignIn from './signIn';
import SignUp from './signUp';
import SignInWithPasswordChange from './signInWithPasswordChange';

const UnauthorizedState = () => {
  const selectedForm = useSelector((store) => store.unauthorizedState.get('selectedForm'));
  const [selectedFormParams, setSelectedFormParams] = useState({});
  const [email, setEmail] = useState();

  useEffect(() => {
    if (selectedForm !== FORMS__SIGN_IN) {
      setSelectedFormParams({});
    }
  }, [selectedForm]);

  return (
    <div className="unauthorized-state">
      <div className="background" />
      <div className="container main-container">
        <Logo />
        <Choose>
          <When condition={selectedForm === FORMS__REMIND_PASSWORD}>
            <RemindPassword />
          </When>
          <When condition={selectedForm === FORMS__SIGN_IN}>
            <SignIn
              selectedFormParams={selectedFormParams}
              onEmailChange={(value) => setEmail(value)}
            />
          </When>
          <When condition={selectedForm === FORMS__SIGN_UP}>
            <SignUp setSelectedFormParams={setSelectedFormParams} />
          </When>
          <When condition={selectedForm === FORMS__SIGN_IN_WITH_PASSWORD_CHANGE}>
            <SignInWithPasswordChange
              email={email}
            />
          </When>
        </Choose>
      </div>
    </div>
  );
};

export default UnauthorizedState;
